import script from "./SidebarMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenuItem.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarMenuItem.vue?vue&type=style&index=0&id=c839b146&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c839b146"]])

export default __exports__